import request from "@/config/axios";
import { getRefreshToken } from "@/utils/auth";
import type { UserLoginVO } from "./types";

export interface SmsCodeVO {
  mobile: string;
  scene: number;
}

export interface SmsLoginVO {
  mobile: string;
  code: string;
}

// 登录
export const login = (data: UserLoginVO) => {
  return request.post({
    url: "/system/auth/login",
    data,
    headers: {
      isEncrypt: true,
    },
  });
};

// 检查密码
export const checkPassword = (data: UserLoginVO) => {
  return request.post({
    url: "/system/auth/check-password",
    data,
    headers: {
      isEncrypt: true,
    },
  });
};

// 刷新访问令牌
export const refreshToken = () => {
  return request.post({ url: "/system/auth/refresh-token?refreshToken=" + getRefreshToken() });
};

// 使用租户名，获得租户编号
export const getTenantIdByName = (name: string) => {
  return request.get({ url: "/system/tenant/get-id-by-name?name=" + name });
};

// 使用租户域名，获得租户信息
export const getTenantByWebsite = (website: string) => {
  return request.get({ url: "/system/tenant/get-by-website?website=" + website });
};

// 根据本地化标识，获得租户信息
export const getTenantByLocalizationFlag = () => {
  return request.get({ url: "/system/tenant/get-by-localizationFlag" });
};

// 登出
export const loginOut = () => {
  return request.post({ url: "/system/auth/logout" });
};

// 获取用户权限信息
export const getInfo = () => {
  return request.get({ url: "/system/auth/get-permission-info" });
};

//获取登录验证码
export const sendSmsCode = (data: SmsCodeVO) => {
  return request.post({ url: "/system/auth/send-sms-code", data });
};

// 短信验证码登录
export const smsLogin = (data: SmsLoginVO) => {
  return request.post({ url: "/system/auth/sms-login", data });
};

// 社交快捷登录，使用 code 授权码
export function socialLogin(type: string, code: string, state: string) {
  return request.post({
    url: "/system/auth/social-login",
    data: {
      type,
      code,
      state,
    },
  });
}

// 社交授权的跳转
export const socialAuthRedirect = (type: number, redirectUri: string) => {
  return request.get({
    url: "/system/auth/social-auth-redirect?type=" + type + "&redirectUri=" + redirectUri,
  });
};
// 获取验证图片以及 token
export const getCode = (data) => {
  return request.postOriginal({ url: "system/captcha/get", data });
};

// 滑动或者点选验证
export const reqCheck = (data) => {
  return request.postOriginal({ url: "system/captcha/check", data });
};

// SSO 登录
export const ssoLogin = (TenantId) => {
  return request.get({ url: "/system/auth/sso-login", headers: { "tenant-id": TenantId } });
};

// 小程序临时授权码登录接口参数
export interface MiniAppAuthCodeReqVO {
  tenantId: number; // 租户ID
  employeeCd: string; // 员工编号
  openid: string; // 微信小程序 openid
  uid: string; // 管理平台用户ID
  hospitalCode: string; // 医院编号
  timestamp: string; // 时间戳（秒）
  randomStr: string; // 随机字符串（4位）
  sign: string; // 签名 = MD5(uid + timestamp + token + randomStr)
}

export interface MiniAppAuthCodeRespVO {
  authCode: string; // 临时授权码
  expiresIn: number; // 有效期（秒）
  tenantId: number; // 租户ID
}

// 生成小程序临时授权码
export const generateMiniAppAuthCode = (data: MiniAppAuthCodeReqVO) => {
  return request.post({ url: "/system/auth/mini-app/auth-code", data });
};

// 小程序临时授权码登录请求参数
export interface MiniAppLoginReqVO {
  tenantId: number; // 租户ID
  authCode: string; // 临时授权码
}

// 小程序临时授权码登录
export const miniAppLogin = (data: MiniAppLoginReqVO) => {
  return request.post({ url: "/system/auth/mini-app/login", data });
};
